const TopFlap = () => (
    <svg
        className="top-flap"
        viewBox="0 0 536 544"
        preserveAspectRatio="none"
    >
        <path
            d="
                M 0 0
                L 536 0
                L 536 255
                L 312 475
                L 224 475
                L 0 255
                Z
            "
            fill="currentColor"
        />
    </svg>
);

export default TopFlap;